webpackJsonp([13],{

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);



var southWest = new __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.LatLng(56.06239, 64.268402),
    northEast = new __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.LatLng(58.275331, 67.019592);

var map = new __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.Map('map', {
    zoomControl: false,
    center: new __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.LatLng(document.clat, /*57.146960113233, 65.548178937072*/document.clon),
    zoom: 17,
    attributionControl: false,
    maxBounds: new __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.LatLngBounds(southWest, northEast)
});

var tileserver = new __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.TileLayer('https://tile.tgt72.ru/{z}/{x}/{y}.png', { maxZoom: 18 });
map.addLayer(tileserver);
map.addControl(__WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.control.zoom({ position: 'topright' }));

var tlIcon = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.icon({
    iconUrl: document.iconUrl,
    iconSize: [16, 16],
    iconAnchor: [16, 16]
});

__WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.marker([document.clat, document.clon], { icon: tlIcon }).addTo(map).bindPopup(document.objectTitle, { offset: new __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.Point(-7, -7) }).openPopup();
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(southWest, 'southWest', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/trafficLightDetail.js');

    __REACT_HOT_LOADER__.register(northEast, 'northEast', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/trafficLightDetail.js');

    __REACT_HOT_LOADER__.register(map, 'map', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/trafficLightDetail.js');

    __REACT_HOT_LOADER__.register(tileserver, 'tileserver', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/trafficLightDetail.js');

    __REACT_HOT_LOADER__.register(tlIcon, 'tlIcon', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/trafficLightDetail.js');
}();

;

/***/ })

},[551]);


// WEBPACK FOOTER //
// trafficLightDetail.js